import Qs from 'qs'
import { Api } from './Api.ts'

const client = new Api({
  baseURL: window.location.origin,
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'brackets' }),
})

client.instance.interceptors.response.use((response) => {
  return response
}, (error) => {
  error.errors = error?.response?.data?.errors || []

  return Promise.reject(error)
})

const token: HTMLElement | null = document.querySelector("[name='csrf-token']")
let tokenContent = 'no-csrf-token'

if (token instanceof HTMLMetaElement) {
  tokenContent = token.content
}

client.instance.defaults.headers['x-csrf-token'] = tokenContent

export const axiosInstance = client.instance
export const apiClient = client
